import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$1 } from './mapy-loader3.js';
import { E as getLink, o as transDialog, g as getLocale, m as getTheme, B as classNames } from './utils2.js';
import { g as FIRM_FOOTER_LINKS } from './const.js';
import { d as defineCustomElement$3 } from './mapy-loader2.js';
import { d as defineCustomElement$2 } from './mapy-review-button2.js';

const mapyReviewDialogFooterCss = ".footer{font-family:Arial}.rulesAndBtn{display:flex;gap:24px;flex-direction:row;align-items:flex-end}.rulesAndBtn p{margin:0;color:#666;font-size:12px;font-style:normal;font-weight:400;line-height:16px;text-align:center;width:100%}.rulesAndBtn.has-button p{text-align:left}.rulesAndBtn p a{color:#1eae00;text-decoration:none}.rulesAndBtn p a:hover{color:#1f7e07}.rulesAndBtn mapy-review-button,.rulesAndBtn .btnLoader{flex:0 0 166px}.rulesAndBtn mapy-review-button{height:36px}.btnLoader{display:flex;justify-content:center;align-items:center;height:36px}.error{height:40px;display:flex;justify-content:center;align-items:flex-start}.errorMsg{margin:0;color:#C00;text-align:center;font-size:12px;font-style:normal;font-weight:400;line-height:16px;margin-top:8px}.errorMsg:empty{display:none}.footer[data-theme=\"firmy\"] .rulesAndBtn p a{color:#c00}.footer[data-theme=\"firmy\"] .rulesAndBtn p a:hover{color:#c00}@media only screen and (max-width: 756px){.rulesAndBtn{flex-direction:column}.rulesAndBtn mapy-review-button,.rulesAndBtn .btnLoader{height:38px;flex:auto}.footer[data-edit=\"yes\"] .rulesAndBtn mapy-review-button{width:100%}}@media only screen and (max-width: 500px){.rulesAndBtn{gap:12px;flex-direction:column-reverse}.rulesAndBtn.has-button p{text-align:center}.rulesAndBtn .btnLoader{flex:0 0 100%;width:100%}.rulesAndBtn mapy-review-button{flex:0 0 100%;width:100%}.error{height:32px}.errorMsg{overflow:hidden;text-overflow:ellipsis;text-transform:none;-webkit-line-clamp:2;-webkit-box-orient:vertical;margin:0}}";
const MapyReviewDialogFooterStyle0 = mapyReviewDialogFooterCss;

defineCustomElement$1();
const MapyReviewDialogFooter = /*@__PURE__*/ proxyCustomElement(class MapyReviewDialogFooter extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.signal = createEvent(this, "signal", 1);
        this.save = createEvent(this, "save", 1);
        this.onSave = () => {
            this.save.emit({});
        };
        this.onClick = (event) => {
            const target = event.target;
            if (target.nodeName.toLowerCase() === "a") {
                this.signal.emit({
                    name: "footer-click",
                    data: target.dataset,
                });
            }
        };
        this.hasButton = false;
        this.isFirm = false;
        this.disabled = false;
        this.error = "";
        this.loading = false;
        this.afterReview = false;
        this.hasReviewText = false;
        this.isEditMode = false;
        this.hasPhotos = false;
        this.service = "mapy";
    }
    getDialogFooterMaps(data) {
        const termsLink = getLink("terms", data.lang);
        const rulesLink = getLink("rules", data.lang, data.isFirm);
        const transKey = this.isEditMode
            ? "acceptLicence"
            : "commentLicence";
        return transDialog(data.lang, transKey, {
            linkAgrStart: `<a href="${termsLink}" target="_blank" data-footer-type="terms" data-href="${termsLink}">`,
            linkAgrEnd: "</a>",
            linkRulStart: `<a href="${rulesLink}" target="_blank" data-footer-type="rules" data-href="${rulesLink}">`,
            linkRulEnd: "</a>",
        });
    }
    getDialogFooterFirms(data) {
        const parts = [];
        const noPhotoPart = transDialog(data.lang, "commentLicenceFirm", {
            linkRulStart: `<a href="${FIRM_FOOTER_LINKS.RULES}" target="_blank" data-footer-type="terms" data-href="${FIRM_FOOTER_LINKS.RULES}">`,
            linkRulEnd: "</a>",
            linkPerStart: `<a href="${FIRM_FOOTER_LINKS.PERSONAL_RULES}" target="_blank" data-footer-type="terms" data-href="${FIRM_FOOTER_LINKS.PERSONAL_RULES}">`,
            linkPerEnd: "</a>",
        });
        parts.push(noPhotoPart);
        if (data.hasPhotos) {
            const photoLink = FIRM_FOOTER_LINKS.LICENCE[data.lang] || FIRM_FOOTER_LINKS.LICENCE.cs;
            const photoPart = transDialog(data.lang, "picturesLinkFirm", {
                linkAgrStart: `<a href="${photoLink}" target="_blank" data-footer-type="terms" data-href="${photoLink}">`,
                linkAgrEnd: "</a>",
            });
            parts.push(photoPart);
        }
        return parts.join(" ");
    }
    getFooter(data) {
        return this.service === "firmy"
            ? this.getDialogFooterFirms(data)
            : this.getDialogFooterMaps(data);
    }
    getBtnTitle(lang) {
        if (this.isEditMode) {
            return transDialog(lang, "save");
        }
        if (this.afterReview) {
            const hasReview = this.hasReviewText || this.hasPhotos;
            return hasReview
                ? transDialog(lang, "addReview")
                : transDialog(lang, "addNothing");
        }
        return transDialog(lang, "continue");
    }
    render() {
        const lang = getLocale(this.hostElement);
        const hasReview = this.hasReviewText || this.hasPhotos;
        const btnTitle = this.getBtnTitle(lang);
        const linksContent = this.getFooter({
            lang: lang,
            isFirm: this.isFirm,
            hasText: this.hasReviewText,
            hasPhotos: this.hasPhotos,
        });
        return h(Host, { key: '62781fc57bcf20756a54557f94992f473b912bd3' }, h("div", { key: 'd83aef791047d76ecb6afbb22777f32834480a47', class: "footer", "data-theme": getTheme(this.service), onClick: this.onClick, "data-edit": this.isEditMode ? "yes" : "no" }, h("div", { key: '85d6139f7406e7ea0a7066271503bc890280a330', class: classNames(["rulesAndBtn", this.hasButton ? "has-button" : ""]) }, h("p", { key: '6d2f029886535d2890dfd6b947f6e924d59423d1', class: "footer-links", innerHTML: linksContent }), (this.hasButton && !this.loading) && h("mapy-review-button", { key: 'fd615d97c79aaaabaacf811dcd884dfa675e5e5b', primary: hasReview || !this.afterReview, onClick: this.onSave, disabled: this.disabled, service: this.service }, btnTitle), (this.hasButton && this.loading) && h("div", { key: 'e6b2d559c972f3a516ca7717a3e4f88e69d2d858', class: "btnLoader" }, h("mapy-loader", { key: '99158e0828163cd4c8b66bcbe9d457ba905e1569' }))), h("div", { key: '4264c4f96d93d6c0339618c7103fbbcdfb27d530', class: "error" }, h("p", { key: '7ea9e28b38dc97f31ed493a00c3d60a761a8d803', class: "errorMsg" }, this.error))));
    }
    get hostElement() { return this; }
    static get style() { return MapyReviewDialogFooterStyle0; }
}, [1, "mapy-review-dialog-footer", {
        "hasButton": [516, "has-button"],
        "isFirm": [516, "is-firm"],
        "disabled": [516],
        "error": [513],
        "loading": [516],
        "afterReview": [516, "after-review"],
        "hasReviewText": [516, "has-review-text"],
        "isEditMode": [516, "is-edit-mode"],
        "hasPhotos": [516, "has-photos"],
        "service": [513]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-dialog-footer", "mapy-loader", "mapy-review-button"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-dialog-footer":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewDialogFooter);
            }
            break;
        case "mapy-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "mapy-review-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewDialogFooter as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-dialog-footer2.js.map